import React, { useEffect, useState } from "react";
import PaginationComponent from "./components/Pagination";
import { Button, Form, Table } from "react-bootstrap";
import EditForm from "./components/EditForm";
import { formatDate, formatDateMMDDYYYY } from "./components/DateFormat";
import AddForm from "./components/Addform";
import axios from "axios";
import { toast } from "react-toastify";

const DataDisplay = ({ initialSheetData, sheetId, dataType = "meeting" }) => {
  // Separate data based on the presence of "Date of Need to Know" in the result
  const [sheetData, setSheetData] = useState(initialSheetData);
  const dataWithDate = [];
  const dataWithoutDate = [];
  const KpiSheetData = [];
  sheetData.forEach(({ sheetName, result }) => {
    console.log(result);

    // Safety check for empty or invalid result
    if (!result || typeof result !== 'object') {
      console.log(`Empty or invalid sheet data for ${sheetName}`);
      return;
    }

    if (result[" Need to Know? (select type)"]) {
      dataWithoutDate.push({ sheetName, result });
    } else if (result["Date of Issue"]) {
      dataWithDate.push({ sheetName, result });
    } else if (result["Custom KPIs"]) {
      KpiSheetData.push({ sheetName, result });
    } else {
      // Handle empty sheets - you can choose which category to put them in
      // or create a separate handling for empty sheets
      console.log(`Empty sheet detected: ${sheetName}`);
      // Optionally add to one of the categories with empty structure:
      // dataWithoutDate.push({ sheetName, result: {} });
    }
  });

  // Separate state for itemsPerPage for each table
  const [itemsPerPageIssueList, setItemsPerPageIssueList] = useState(5);
  const [itemsPerPageNeedToKnow, setItemsPerPageNeedToKnow] = useState(5);
  const [itemsPerPageKPI, setItemsPerPageKPI] = useState(5);

  const updateSheetData = (updatedSheetName, updatedRowData, isNew = false) => {
    setSheetData((prevSheetData) =>
      prevSheetData.map((sheet) => {
        if (sheet.sheetName === updatedSheetName) {
          const headers = Object.keys(sheet.result || {});

          if (headers.length === 0) {
            console.warn(`No headers found for sheet: ${updatedSheetName}`);
            return sheet;
          }

          if (isNew) {
            // Handle new row logic (existing code)
            const firstHeader = headers[0];
            const currentRowCount = sheet.result[firstHeader] ? sheet.result[firstHeader].length : 0;

            if (dataType === "meeting") {
              if (headers.includes("Item #")) {
                updatedRowData["Item #"] = currentRowCount + 1;
              }
            } else if (dataType === "kpi") {
              const idField = headers.find(header =>
                header.toLowerCase().includes('id') ||
                header.toLowerCase().includes('number') ||
                header === '#'
              );
              if (idField) {
                updatedRowData[idField] = currentRowCount + 1;
              }
            }

            headers.forEach((header) => {
              if (!Array.isArray(sheet.result[header])) {
                sheet.result[header] = [];
              }
              const valueToAdd = updatedRowData.hasOwnProperty(header) ? updatedRowData[header] : "";
              sheet.result[header].push(valueToAdd);
            });
          } else {
            // Update existing row
            let rowIndex = -1;

            // Use the internal row index if available
            if (updatedRowData["__internal_rowIndex"] !== undefined) {
              rowIndex = updatedRowData["__internal_rowIndex"];
              delete updatedRowData["__internal_rowIndex"]; // Remove internal field
            } else if (dataType === "meeting" && headers.includes("Item #") && updatedRowData["Item #"]) {
              // For meeting sheets, use Item # as identifier
              const itemValues = sheet.result["Item #"];
              rowIndex = itemValues.findIndex(val => val.toString() === updatedRowData["Item #"].toString());
            } else {
              // For KPI sheets without internal index, try to find by Custom KPIs
              if (headers.includes("Custom KPIs") && updatedRowData["Custom KPIs"]) {
                const kpiValues = sheet.result["Custom KPIs"];
                rowIndex = kpiValues.findIndex(val => val.toString() === updatedRowData["Custom KPIs"].toString());
              }
            }

            if (rowIndex !== -1) {
              headers.forEach((header) => {
                if (updatedRowData.hasOwnProperty(header) && header !== "__internal_rowIndex") {
                  sheet.result[header][rowIndex] = updatedRowData[header];
                }
              });
              console.log(`Successfully updated row ${rowIndex} in sheet: ${updatedSheetName}`);
            } else {
              console.error(`Could not find row to update in sheet: ${updatedSheetName}`);
            }
          }
        }
        return sheet;
      })
    );
  };

  // Only process data relevant to the dataType
  const shouldShowNeedToKnow = dataType === "meeting" && dataWithoutDate.length > 0;
  const shouldShowIssueList = dataType === "meeting" && dataWithDate.length > 0;
  const shouldShowKPI = (dataType === "kpi" || dataType === "meeting") && KpiSheetData.length > 0;

  return (
    <div>
      {/* Need to Know Table Configuration */}
      {shouldShowNeedToKnow && (
      <div className="table-container p-2 shadow-lg">
        <h2 className="text-center my-3">Need to Knows</h2>
        <div className="leftside w-100 ">
          1.{" "}
          {/* <span className="text-decoration-underline fw-bold fs-4">
            Need To Knows:
          </span>{" "} */}
          Report in on noteworthy staff performance, problems or shifts; client
          developments; suppliers exceeding or failing to meet expectation.
          Wherever possible, tie these accolades or challenges to the Values.
          Add any issues to D3
        </div>
        <div className="d-flex justify-content-end">
          <Form.Group
            className="d-flex justify-content-end"
            controlId="itemsPerPageSelectNeedToKnow"
            style={{ width: "20%" }}
          >
            <Form.Label>Rows per page (Need to Knows):</Form.Label>
            <Form.Control
              as="select"
              value={itemsPerPageNeedToKnow}
              onChange={(e) =>
                setItemsPerPageNeedToKnow(Number(e.target.value))
              }
            >
              <option value={2}>2</option>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
            </Form.Control>
          </Form.Group>
        </div>
        <DataTable
          data={dataWithoutDate}
          itemsPerPage={itemsPerPageNeedToKnow}
          updateSheetData={updateSheetData}
          sheetId={sheetId}
        />
        </div>
      )}
      {/* Issue List Table Configuration */}
      {shouldShowIssueList && (
      <div className="table-container p-2 shadow-lg">
        <h2 className="text-center my-3">Issue List</h2>
        <div className="leftside w-100">
          2. <span className="text-decoration-underline fw-bold fs-4">D3:</span>{" "}
          : (Discuss, Decide, Do: any issues that emerge from the above
          categories are to be discussed. From that discussion, either a
          decision is to be made or some action needs to be taken. If a decision
          is made, it can come off the D3 list. If a to do is identified, it
          remains on the list until the to do is completed AND the issue is
          resolved.)
        </div>
        <div className="d-flex justify-content-end">
          <Form.Group
            className="d-flex justify-content-end"
            controlId="itemsPerPageSelectIssueList"
            style={{ width: "20%" }}
          >
            <Form.Label>Rows per page (Issue List):</Form.Label>
            <Form.Control
              as="select"
              value={itemsPerPageIssueList}
              onChange={(e) => setItemsPerPageIssueList(Number(e.target.value))}
            >
              <option value={2}>2</option>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
            </Form.Control>
          </Form.Group>
        </div>
        <DataTable
          data={dataWithDate}
          itemsPerPage={itemsPerPageIssueList}
          updateSheetData={updateSheetData}
          sheetId={sheetId}
        />
        </div>
      )}
      {/* KPI List Table Configuration */}
      {shouldShowKPI && (
      <div className="table-container p-2 shadow-lg">
        <h2 className="text-center my-3">KPI List</h2>
        <div className="leftside w-100">
          3.{" "}
          <span className="text-decoration-underline fw-bold fs-4">
            OODA Loop:
          </span>{" "}
          : (Observe, Orient, Decide, Act. . Do you need to shift, allocate more
          resources, raise or lower a priority? In light of these new insights,
          is there is a new, better or revised choice? If so, then Act by
          adjusting the plan and put that into action.)
        </div>
        <div className="d-flex justify-content-end">
          <Form.Group
            className="d-flex justify-content-end"
            controlId="itemsPerPageSelectIssueList"
            style={{ width: "20%" }}
          >
            <Form.Label>Rows per page (KPI List):</Form.Label>
            <Form.Control
              as="select"
              value={itemsPerPageKPI}
              onChange={(e) => setItemsPerPageKPI(Number(e.target.value))}
            >
              <option value={2}>2</option>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
            </Form.Control>
          </Form.Group>
        </div>
        <DataTable
          data={KpiSheetData}
          itemsPerPage={itemsPerPageKPI}
          updateSheetData={updateSheetData}
          sheetId={sheetId}
        />
      </div>
      )}

      {!shouldShowNeedToKnow && !shouldShowIssueList && !shouldShowKPI && (
        <div className="text-center p-4">
          <p>No data available for this {dataType} type</p>
        </div>
      )}
    </div>
  );
};

const DataTable = ({ data, itemsPerPage, updateSheetData, sheetId }) => {
  const [pageStates, setPageStates] = useState(
    data.map(() => 1) // Initialize currentPage state for each table
  );

  const apiUrl = process.env.REACT_APP_BACKEND_API;
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedSheetName, setSelectedSheetName] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [addHeaders, setAddHeaders] = useState([]);
  const [addSheetName, setAddSheetName] = useState("");

  if (!data || data.length === 0) {
    return (
      <div className="text-center p-4">
        <p>No data available for this section</p>
      </div>
    );
  }
  const handlePageChange = (pageNumber, tableIndex) => {
    const newPageStates = [...pageStates];
    newPageStates[tableIndex] = pageNumber;
    setPageStates(newPageStates);
  };

  const extractRowData = (headers, result, rowIndex, indexOfFirstItem) => {
    const actualRowIndex = indexOfFirstItem + rowIndex;
    const extractedData = headers.reduce((acc, header) => {
      let value = result[header] && result[header][actualRowIndex] !== undefined
        ? result[header][actualRowIndex]
        : "";

      if (value === undefined || value === null) {
        value = "";
      }

      acc[header] = value;
      return acc;
    }, {});

    // Add row position internally but don't show it in the edit form
    extractedData["__internal_rowIndex"] = actualRowIndex;

    return extractedData;
  };

  const handleActionClick = (rowData, sheetName) => {
    // Handle action button click here
    console.log("Action clicked for row:", sheetName, rowData);
    const formattedData = Object.keys(rowData).reduce((acc, key) => {
      if (key.includes("Date")) {
        acc[key] = formatDate(rowData[key]);
      } else {
        acc[key] = rowData[key];
      }
      return acc;
    }, {});
    setSelectedSheetName(sheetName);
    setSelectedData(formattedData);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);
  const handleUpdate = async (sheetName, updatedData) => {
    // Extract the internal row index before processing
    const internalRowIndex = updatedData["__internal_rowIndex"];

    // Clean the data and remove internal fields
    const cleanedData = { ...updatedData };
    delete cleanedData["__internal_rowIndex"];

    const formattedData = Object.keys(cleanedData).reduce((acc, key) => {
      let value = cleanedData[key];
      if (value === undefined || value === null) {
        value = "";
      } else if (key.includes("Date") && value !== "") {
        value = formatDateMMDDYYYY(value);
      } else {
        value = String(value);
      }
      acc[key] = value;
      return acc;
    }, {});

    console.log("Sending to server:", { sheetId, sheetName, formattedData });

    try {
      const res = await axios.post(`${apiUrl}/meeting/updateData`, {
        sheetId,
        sheetName,
        formattedData,
      });

      if (res.data.success) {
        // Add the internal row index back for frontend update
        if (internalRowIndex !== undefined) {
          formattedData["__internal_rowIndex"] = internalRowIndex;
        }

        updateSheetData(sheetName, formattedData);
        toast.success("Updated successfully!");
      } else {
        toast.error(res.data.message || "Failed to Update! try again..");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Failed to Update! try again..");
    }
    handleCloseModal();
  };

  //================= Handle Add data to Sheet ==================

  const handleAddClick = (headers, sheetName) => {
    setAddHeaders(headers);
    setAddSheetName(sheetName);
    setShowAddModal(true);
  };
  // console.log(sheetId);
  const handleAdd = async (sheetName, newData) => {
    // console.log(newData);
    const formattedData = Object.keys(newData).reduce((acc, key) => {
      if (key.includes("Date")) {
        acc[key] = formatDateMMDDYYYY(newData[key]);
      } else {
        acc[key] = newData[key];
      }
      return acc;
    }, {});
    // console.log(formattedData);
    // Define required fields
    // Define validation rules for different sets of fields
    const validationRules = [
      {
        requiredFields: ["Date of Issue"],
        fieldsToCheck: ["Date of Issue"],
      },
      {
        requiredFields: ["Date of Need to Know"],
        fieldsToCheck: ["Date of Need to Know"],
      },
    ];

    // Find the applicable validation rules based on the fields present in formattedData
    const applicableRules = validationRules.find((rule) =>
      rule.fieldsToCheck.some((field) => formattedData.hasOwnProperty(field))
    );

    if (applicableRules) {
      const missingOrEmptyFields = applicableRules.requiredFields.filter(
        (field) =>
          formattedData.hasOwnProperty(field) &&
          (formattedData[field] === undefined ||
            formattedData[field] === null ||
            formattedData[field].trim() === "")
      );

      if (missingOrEmptyFields.length > 0) {
        toast.error(`${missingOrEmptyFields.join(", ")} is missing or empty.`);
        return;
      }
    }

    // console.log(sheetName, formattedData);
    try {
      // const res = await axios.post(`http://localhost:3333/meeting/addData`, {
      const res = await axios.post(`${apiUrl}/meeting/addData`, {
        sheetId,
        sheetName,
        formattedData,
      });
      console.log(res.data);
      if (res.data?.success) {
        updateSheetData(sheetName, formattedData, true); // Pass true for isNew
      } else {
        toast.error("Faild to Add! try again..");
      }
    } catch (error) {
      console.log(error.message);
    }
    handleCloseAddModal();
  };

  const handleCloseAddModal = () => setShowAddModal(false);

  return (
    <div>
      {data.map(({ sheetName, result }, tableIndex) => {
        // With this safe version:
        const headers = Object.keys(result || {});

        // If no headers or empty result, show empty state
        if (headers.length === 0) {
          return (
            <div key={tableIndex} className="text-center p-4">
              <h5>{sheetName}</h5>
              <p>No data available in this sheet</p>
              <Button
                className="buttonAddStep mb-2"
                style={{ width: "12%" }}
                onClick={() => handleAddClick([], sheetName)}
              >
                Add First Row
              </Button>
            </div>
          );
        }
        const firstHeader = headers[0];
        const totalRows = (result && firstHeader && Array.isArray(result[firstHeader]))
          ? result[firstHeader].length
          : 0;
        const totalPages = Math.max(1, Math.ceil(totalRows / itemsPerPage));

        // Calculate the range of rows to display on the current page
        const currentPage = pageStates[tableIndex];
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentRows = (headers.length && result && result[headers[0]] && Array.isArray(result[headers[0]]))
          ? result[headers[0]].slice(indexOfFirstItem, indexOfLastItem)
          : [];
        return (
          <div key={tableIndex}>
            <Button
              className="buttonAddStep mb-2"
              style={{ width: "12%" }}
              onClick={() => handleAddClick(headers, sheetName)}
            >
              Add New Row
            </Button>
            <div className="pagination-table">
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    {headers.map((header) => (
                      <th key={header}>{header}</th>
                    ))}
                    <th>Action</th> {/* Additional header for Action */}
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((_, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className={`${
                        result["Closed?"] &&
                        result["Closed?"][indexOfFirstItem + rowIndex] === "Yes"
                          ? "closedIssue"
                          : ""
                      }`}
                    >
                      {headers.map((header) => (
                        <td key={header}>
                          {result[header][indexOfFirstItem + rowIndex]}
                        </td>
                      ))}
                      <td>
                        <Button
                          className="buttonAddStep"
                          onClick={() =>
                            handleActionClick(
                              extractRowData(
                                headers,
                                result,
                                rowIndex,
                                indexOfFirstItem
                              ),
                              sheetName
                            )
                          }
                        >
                          Edit
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <PaginationComponent
              currentPage={currentPage}
              totalPages={totalPages}
              handlePageChange={(page) => handlePageChange(page, tableIndex)}
            />
          </div>
        );
      })}
      {showModal && (
        <EditForm
          show={showModal}
          handleClose={handleCloseModal}
          initialData={selectedData}
          sheetName={selectedSheetName}
          handleUpdate={handleUpdate}
        />
      )}
      {showAddModal && (
        <AddForm
          show={showAddModal}
          handleClose={handleCloseAddModal}
          headers={addHeaders}
          sheetName={addSheetName}
          handleAdd={handleAdd}
        />
      )}
    </div>
  );
};
export default DataDisplay;
